// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/delete_patient.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.DeletePatientRequest
 */
export class DeletePatientRequest extends Message<DeletePatientRequest> {
  /**
   * Unique identifier for the patient to be deleted
   *
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  /**
   * Reason for deleting the patient record (optional)
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<DeletePatientRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DeletePatientRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePatientRequest {
    return new DeletePatientRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePatientRequest {
    return new DeletePatientRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePatientRequest {
    return new DeletePatientRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePatientRequest | PlainMessage<DeletePatientRequest> | undefined, b: DeletePatientRequest | PlainMessage<DeletePatientRequest> | undefined): boolean {
    return proto3.util.equals(DeletePatientRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.DeletePatientResponse
 */
export class DeletePatientResponse extends Message<DeletePatientResponse> {
  constructor(data?: PartialMessage<DeletePatientResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DeletePatientResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePatientResponse {
    return new DeletePatientResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePatientResponse {
    return new DeletePatientResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePatientResponse {
    return new DeletePatientResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePatientResponse | PlainMessage<DeletePatientResponse> | undefined, b: DeletePatientResponse | PlainMessage<DeletePatientResponse> | undefined): boolean {
    return proto3.util.equals(DeletePatientResponse, a, b);
  }
}

